module.exports = __webpack_public_path__ + "img/txt.4ec4cba0.png";